export const formatFollowerCountLabel = ({ followerCount, t }) => {
  const singularLabel = t('common:singularFollowerCount');
  const pluralLabel = t('common:pluralFollowerCount');
  return followerCount
    ? `${followerCount} ${followerCount > 1 ? pluralLabel : singularLabel}`
    : undefined;
};
